import React, { useState } from "react";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import logo from ".././images/Forcesight_Logo.svg";
import Fs_icon from ".././images/forcesightIcon.png";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { clearFilterState } from "../utils/statePersistence.js";
import DeepAnalysisNotifier from "../pages/Money/DeepAnalysisNotifier.js";

const mapStateToProps = (state) => {
  return {
    sliderCollapsed: state.filter.sliderCollapsed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateSliderFilter: (sliderInfo) =>
      dispatch({
        type: "filter/updateSliderFilter",
        payload: {
          sliderCollapsed: sliderInfo.sliderCollapsed,
        },
      }),
  };
};

function CustomSideBar({ children, sliderCollapsed, ...props }) {
  const moduleAccess = JSON.parse(localStorage.getItem("org_modules"));
  const userEmail = JSON.parse(localStorage.getItem("user_info")) || {};
  const isLoginAdmin = JSON.parse(localStorage.getItem("isLoginAdmin"));
  const adminEmail = localStorage.getItem("email");
  const isAgencyLogin = JSON.parse(localStorage.getItem("isAgencyDashboard"));
  const allowedEmails = [
    "anush@forcesight.ai",
    "demo_login@forcesight.in",
    "demouser@forcesight.in",
  ];
  const location = useLocation();
  const history = useNavigate();
  // money menu (independent open/close — no cross-close with other menus) ---
  const [moneyOpen, setMoneyOpen] = useState(
    location.pathname.startsWith("/money"),
  );
  const handleMoneyClick = () => setMoneyOpen((v) => !v);
  // profiit menu -----------------------------------
  const [optimizeProfitOpen, setOptimizeProfitOpen] = useState(
    !!(
      location.pathname === "/profitability/0" ||
      location.pathname === "/profit-analysis" ||
      location.pathname === "/profitability/2" ||
      location.pathname === "/profit-loss-monthly" ||
      location.pathname === "/dashboard"
    ),
  );
  // payments menu -----------------------------------
  const [paymentsOpen, setPaymentsOpen] = useState(
    !!(
      location.pathname === "/payment-tracker/0" ||
      location.pathname === "/outstanding-payments" ||
      location.pathname === "/payment-tracker/1" ||
      location.pathname === "/payment-tracker/2" ||
      location.pathname === "/invoice-po" ||
      location.pathname === "/amazonvcp-recon" ||
      location.pathname === "/quickcommerce-payments" ||
      location.pathname === "/po-rec-others" ||
      location.pathname === "/quickcommerce-ledger" ||
      location.pathname === "/fee-waiver-recon" ||
      location.pathname === "/settled-amount-recon" ||
      location.pathname === "/returns-summary" ||
      location.pathname === "/returns-tracker" ||
      location.pathname === "/claims-summary" ||
      location.pathname === "/claims" ||
      location.pathname === "/manual_claims"
    ),
  );
  // payments menu --------Recon---------------------------
  const [paymentsReconOpen, setPaymentsReconOpen] = useState(
    !!(
      location.pathname === "/payment-tracker/1" ||
      location.pathname === "/payment-tracker/2" ||
      location.pathname === "/invoice-po"
    ),
  );
  // payments menu --------PO---------------------------
  const [paymentsPoOpen, setPaymentsPoOpen] = useState(
    !!(
      location.pathname === "/amazonvcp-recon" ||
      location.pathname === "/quickcommerce-payments" ||
      location.pathname === "/po-rec-others" ||
      location.pathname === "/b2B-recon-summary" ||
      location.pathname === "/quickcommerce-ledger"
    ),
  );
  // payments menu --------Returns---------------------------
  const [returnsViewOpen, setReturnsViewOpen] = useState(
    !!(
      location.pathname === "/returns-summary" ||
      location.pathname === "/returns-tracker"
    ),
  );
  // Payments menu ----------Claims-------------------------
  const [claimOpen, setClaimOpen] = useState(
    !!(
      location.pathname === "/claims-summary" ||
      location.pathname === "/claims" ||
      location.pathname === "/manual_claims"
    ),
  );

  // --------------------------------New Payments Menu Start---------------------------

  // payments menu -----------------------------------
  const [newPaymentsOpen, setNewPaymentsOpen] = useState(
    !!(
      location.pathname === "/payments-summary" ||
      location.pathname === "/payments-outstanding" ||
      location.pathname === "/payments-bank-transfer" ||
      location.pathname === "/payments-b2c" ||
      location.pathname === "/po-rec-others" ||
      location.pathname === "/b2B-recon-summary" ||
      location.pathname === "/payments-d2c" ||
      location.pathname === "/invoice-po" ||
      location.pathname === "/fee-waiver-recon" ||
      location.pathname === "/settled-amount-recon"
    ),
  );

  // -------------------------------New Payments Menu End---------------------------
  // inventory menu -----------------------------------
  const [inventoryOpen, setInventoryOpen] = useState(
    !!(
      location.pathname === "/inventory/2" ||
      location.pathname === "/inventory/3"
    ),
  );

  // inventory (Demand Forecasting) menu -----------------------------------
  const [inventoryTabOpen, setInventoryTabOpen] = useState(
    location.pathname.startsWith("/demand-forecasting"),
  );
  const handleInventoryTabClick = () => setInventoryTabOpen((v) => !v);

  // reviews menu -----------------------------------
  const [reviewsOpen, setReviewsOpen] = useState(
    !!(
      location.pathname === "/reviews/0" ||
      location.pathname === "/reviews/1" ||
      location.pathname === "/reviews/3" ||
      location.pathname === "/reviews/4" ||
      location.pathname === "/reviews/5"
    ),
  );
  // product intelligence menu -----------------------------------
  const [productIntelOpen, setProductIntelOpen] = useState(
    !!(
      location.pathname === "/price-tracker/2" ||
      location.pathname === "/price-tracker/3" ||
      location.pathname === "/PricetrackerV2" ||
      location.pathname === "/buybox-multiple-pincode"
    ),
  );
  // product intelligence menu --------Compliance---------------------------
  const [complianceViewOpen, setComplianceViewOpen] = useState(
    !!(
      location.pathname === "/price-tracker/2" ||
      location.pathname === "/price-tracker/3"
    ),
  );
  // product intelligence menu --------Buy Box---------------------------
  const [buyboxOpen, setBuyboxOpen] = useState(
    !!(location.pathname === "/buybox-multiple-pincode"),
  );
  // settings menu -----------------------------------
  const [settingsOpen, setSettingsOpen] = useState(
    !!(
      location.pathname === "/overview-settings" ||
      location.pathname === "/product-configuration" ||
      location.pathname === "/finance-configuration" ||
      // location.pathname === "/productconfig/0" ||
      // location.pathname === "/other-expenses" ||
      // location.pathname === "/add-exception-rules" ||
      // location.pathname === "/productconfig/1" ||
      // location.pathname === "/productconfig/2" ||
      // location.pathname === "/cashback" ||
      // location.pathname === "/productconfig/3" ||
      // location.pathname === "/fee-waiver-config" ||
      // location.pathname === "/settled-amount-config" ||
      location.pathname === "/reviews/6" ||
      location.pathname === "/account-settings/account" ||
      location.pathname === "/marketplace-settings-dashboard" ||
      location.pathname === "/account-settings/user"
    ),
  );
  // settings menu --------Product Settings---------------------------
  const [productSettingsOpen, setProductSettingsOpen] = useState(
    !!(
      (
        location.pathname === "/overview-settings" ||
        location.pathname === "/product-configuration" ||
        location.pathname === "/finance-configuration" ||
        location.pathname === "/reviews/6"
      )
      // location.pathname === "/productconfig/0" ||
      // location.pathname === "/other-expenses" ||
      // location.pathname === "/add-exception-rules" ||
      // location.pathname === "/productconfig/1" ||
      // location.pathname === "/productconfig/2" ||
      // location.pathname === "/cashback" ||
      // location.pathname === "/productconfig/3" ||
      // location.pathname === "/fee-waiver-config" ||
      // location.pathname === "/settled-amount-config" ||
    ),
  );
  // settings menu --------User Settings---------------------------
  const [userSettingsOpen, setUserSettingsOpen] = useState(
    !!(
      location.pathname === "/account-settings/account" ||
      location.pathname === "/marketplace-settings-dashboard" ||
      location.pathname === "/account-settings/user"
    ),
  );

  const handleOptimizeProfitClick = () => {
    // Close all other menus first
    setPaymentsOpen(false);
    setNewPaymentsOpen(false);
    setPaymentsReconOpen(false);
    setPaymentsPoOpen(false);
    setReturnsViewOpen(false);
    setClaimOpen(false);
    setInventoryOpen(false);
    setReviewsOpen(false);
    setProductIntelOpen(false);
    setComplianceViewOpen(false);
    setSettingsOpen(false);
    setBuyboxOpen(false);
    setProductSettingsOpen(false);
    setUserSettingsOpen(false);

    // Then toggle the current menu
    setOptimizeProfitOpen((prevState) => !prevState);
  };
  const handlePaymentsClick = () => {
    // Close all other menus first
    setOptimizeProfitOpen(false);
    setInventoryOpen(false);
    setReviewsOpen(false);
    setProductIntelOpen(false);
    setComplianceViewOpen(false);
    setSettingsOpen(false);
    setBuyboxOpen(false);
    setUserSettingsOpen(false);
    setProductSettingsOpen(false);
    // Then toggle the current menu
    setPaymentsOpen((prevState) => !prevState);
  };

  const handleNewPaymentsClick = () => {
    // Close all other menus first
    setOptimizeProfitOpen(false);
    setInventoryOpen(false);
    setReviewsOpen(false);
    setProductIntelOpen(false);
    setComplianceViewOpen(false);
    setSettingsOpen(false);
    setBuyboxOpen(false);
    setUserSettingsOpen(false);
    setProductSettingsOpen(false);
    // Then toggle the current menu
    setNewPaymentsOpen((prevState) => !prevState);
  };

  const handlePaymentsReconClick = () => {
    // Close other submenus within Payments first

    setPaymentsPoOpen(false);
    setReturnsViewOpen(false);
    setClaimOpen(false);
    setOptimizeProfitOpen(false);
    setInventoryOpen(false);
    setReviewsOpen(false);
    setProductIntelOpen(false);
    setComplianceViewOpen(false);
    setBuyboxOpen(false);
    setSettingsOpen(false);
    setProductSettingsOpen(false);
    setUserSettingsOpen(false);

    // Then toggle the current submenu
    setPaymentsReconOpen((prevState) => !prevState);
  };

  const handlePaymentsPOClick = () => {
    // Close other submenus within Payments first
    setPaymentsReconOpen(false);
    setReturnsViewOpen(false);
    setClaimOpen(false);
    setOptimizeProfitOpen(false);
    setInventoryOpen(false);
    setReviewsOpen(false);
    setProductIntelOpen(false);
    setComplianceViewOpen(false);
    setBuyboxOpen(false);
    setSettingsOpen(false);
    setProductSettingsOpen(false);
    setUserSettingsOpen(false);
    // Then toggle the current submenu
    setPaymentsPoOpen((prevState) => !prevState);
  };
  // close within payments if any submenu is open
  const handlePaymentsCommoncloseClick = () => {
    setPaymentsPoOpen(false);
    setPaymentsReconOpen(false);
    setReturnsViewOpen(false);
    setClaimOpen(false);
  };
  const handleNewPaymentsCommoncloseClick = () => {
    setReturnsViewOpen(false);
    setClaimOpen(false);
  };

  const handleReturnsClick = () => {
    // Close all other menus first
    setPaymentsReconOpen(false);
    setPaymentsPoOpen(false);
    setClaimOpen(false);
    setOptimizeProfitOpen(false);
    setInventoryOpen(false);
    setReviewsOpen(false);
    setProductIntelOpen(false);
    setComplianceViewOpen(false);
    setBuyboxOpen(false);
    setSettingsOpen(false);
    setProductSettingsOpen(false);
    setUserSettingsOpen(false);
    // Then toggle the current menu
    setReturnsViewOpen((prevState) => !prevState);
  };
  const handleClaimsClick = () => {
    // Close all other menus first
    setPaymentsReconOpen(false);
    setPaymentsPoOpen(false);
    setReturnsViewOpen(false);
    setOptimizeProfitOpen(false);
    setInventoryOpen(false);
    setReviewsOpen(false);
    setProductIntelOpen(false);
    setComplianceViewOpen(false);
    setBuyboxOpen(false);
    setSettingsOpen(false);
    setProductSettingsOpen(false);
    setUserSettingsOpen(false);
    // Then toggle the current menu
    setClaimOpen((prevState) => !prevState);
  };

  const handleInventoryClick = () => {
    // Close all other menus first
    setOptimizeProfitOpen(false);
    setPaymentsOpen(false);
    setNewPaymentsOpen(false);
    setClaimOpen(false);
    setReturnsViewOpen(false);
    setReviewsOpen(false);
    setProductIntelOpen(false);
    setComplianceViewOpen(false);
    setSettingsOpen(false);
    setBuyboxOpen(false);
    setUserSettingsOpen(false);
    setPaymentsReconOpen(false);
    setPaymentsPoOpen(false);
    setProductSettingsOpen(false);

    // Then toggle the current menu
    setInventoryOpen((prevState) => !prevState);
  };

  const handleReviewsClick = () => {
    // Close all other menus first
    setOptimizeProfitOpen(false);
    setPaymentsOpen(false);
    setNewPaymentsOpen(false);
    setClaimOpen(false);
    setReturnsViewOpen(false);
    setInventoryOpen(false);
    setProductIntelOpen(false);
    setComplianceViewOpen(false);
    setSettingsOpen(false);
    setBuyboxOpen(false);
    setUserSettingsOpen(false);
    setPaymentsReconOpen(false);
    setPaymentsPoOpen(false);
    setProductSettingsOpen(false);
    // Then toggle the current menu
    setReviewsOpen((prevState) => !prevState);
  };
  const handleProductIntelClick = () => {
    // Close all other menus first
    setOptimizeProfitOpen(false);
    setPaymentsOpen(false);
    setNewPaymentsOpen(false);
    setClaimOpen(false);
    setReturnsViewOpen(false);
    setInventoryOpen(false);
    setReviewsOpen(false);
    setComplianceViewOpen(false);
    setSettingsOpen(false);
    setBuyboxOpen(false);
    setUserSettingsOpen(false);
    // Then toggle the current menu
    setProductIntelOpen((prevState) => !prevState);
  };

  const handleComplianceViewClick = () => {
    // Close other submenus within Product Intelligence first
    setBuyboxOpen(false);
    // Then toggle the current submenu
    setComplianceViewOpen((prevState) => !prevState);
  };
  const handleBuyboxClick = () => {
    setComplianceViewOpen(false);
    setBuyboxOpen((prevState) => !prevState);
  };
  const handleSettingsClick = () => {
    // Close all other menus first
    setOptimizeProfitOpen(false);
    setPaymentsOpen(false);
    setNewPaymentsOpen(false);
    setClaimOpen(false);
    setReturnsViewOpen(false);
    setInventoryOpen(false);
    setReviewsOpen(false);
    setProductIntelOpen(false);
    setComplianceViewOpen(false);
    setBuyboxOpen(false);
    setPaymentsReconOpen(false);
    setPaymentsPoOpen(false);

    // Then toggle the current menu
    setSettingsOpen((prevState) => !prevState);
  };
  const handleProductSettingsClick = () => {
    // Close all other menus first
    setUserSettingsOpen(false);
    setOptimizeProfitOpen(false);
    setPaymentsOpen(false);
    setNewPaymentsOpen(false);
    setClaimOpen(false);
    setReturnsViewOpen(false);
    setInventoryOpen(false);
    setReviewsOpen(false);
    setProductIntelOpen(false);
    setComplianceViewOpen(false);
    setBuyboxOpen(false);
    setPaymentsReconOpen(false);
    setPaymentsPoOpen(false);
    // Then toggle the current menu
    setProductSettingsOpen((prevState) => !prevState);
  };
  const handleUserSettingsClick = () => {
    // Close all other menus first
    setProductSettingsOpen(false);
    setOptimizeProfitOpen(false);
    setPaymentsOpen(false);
    setNewPaymentsOpen(false);
    setClaimOpen(false);
    setReturnsViewOpen(false);
    setInventoryOpen(false);
    setReviewsOpen(false);
    setProductIntelOpen(false);
    setComplianceViewOpen(false);
    setBuyboxOpen(false);
    setPaymentsReconOpen(false);
    setPaymentsPoOpen(false);
    // Then toggle the current menu
    setUserSettingsOpen((prevState) => !prevState);
  };

  const handleSliderCollapse = () => {
    props.updateSliderFilter({
      sliderCollapsed: !sliderCollapsed,
    });
  };

  const getMenuItemStyles = (path) => {
    const isActive = location.pathname === path;
    return {
      backgroundColor: isActive ? "#CCE5FF" : "",
      color: isActive ? "#007FFF" : "",
      borderRadius: isActive ? "5px" : "",
      margin: "1px",
      fontWeight: isActive ? "600" : "400",
    };
  };

  const getSubMenuStyles = (paths) => {
    const isActive = paths.some((path) => location.pathname === path);
    return {
      backgroundColor: isActive ? "#E3F2FD" : "",
      color: isActive ? "#1976D2" : "",
      borderRadius: isActive ? "5px" : "",
      margin: "1px",
      fontWeight: isActive ? "600" : "500",
    };
  };

  const isParentMenuActive = (parentPaths) => {
    return parentPaths.some((path) => location.pathname === path);
  };
  const handleLogoutClick = (e) => {
    if (!localStorage.getItem("fs_token")) {
      clearFilterState();
      localStorage.clear();
      history("/login");
    } else {
      let admin_token = localStorage.getItem("fs_token");
      let admin_refresh_token = localStorage.getItem("fs_refresh_token");
      let user_info = localStorage.getItem("fs_user_info");
      let cmpy_info = localStorage.getItem("fs_cmpy_info");
      localStorage.setItem("token", admin_token);
      localStorage.setItem("refresh_token", admin_refresh_token);
      localStorage.setItem("user_info", user_info);
      localStorage.setItem("cmpy_info", cmpy_info);
      localStorage.removeItem("fs_user_info");
      localStorage.removeItem("fs_cmpy_info");
      localStorage.removeItem("fs_token");
      localStorage.removeItem("fs_refresh_token");
      localStorage.removeItem("subscriptionDays");
      // common filter
      localStorage.removeItem("profitFilterData");
      localStorage.removeItem("ratingFilter");
      localStorage.removeItem("orderStatusFilter");
      localStorage.removeItem("returnStatusFilter");
      localStorage.removeItem("fullfilmemtFilter");
      localStorage.removeItem("warehouseFilter");
      localStorage.removeItem("masterSetFilter");
      // localStorage.removeItem("finalMasterSetFilter");
      clearFilterState();

      history("/admin-dashboard");
    }
  };
  const handleDashboardClick = (e) => {
    history(
      userEmail?.email === "gitasureka@yahoo.co.in" && !isLoginAdmin
        ? "/profitability/2"
        : "/profitability/0",
    );
  };
  return (
    // <div style={{  height: "100%", minHeight: "400px" }}>
    <div className="mainWrapper">
      {/* Renders nothing — raises the "deep analysis ready" banner on any page. */}
      <DeepAnalysisNotifier />
      <Sidebar
        backgroundColor="#FFFFFF"
        collapsed={sliderCollapsed}
        className="fixed h-screen"
        width="228px"
        // collapsedWidth="60px"
        transitionDuration={1000}
        rootStyles={{
          // border: "none",
          zIndex: 1000,
        }}
      >
        <div className="flex justify-center items-center bg-white py-3">
          <div
            className="flex items-center cursor-pointer"
            onClick={handleDashboardClick}
          >
            <Link
              to={
                userEmail?.email === "gitasureka@yahoo.co.in" && !isLoginAdmin
                  ? "/profitability/2"
                  : "/profitability/0"
              }
            >
              <img
                className={`${
                  sliderCollapsed
                    ? "block lg:hidden h-4 w-auto"
                    : "block lg:hidden h-8 w-auto"
                }`}
                src={sliderCollapsed ? Fs_icon : logo}
                alt="Workflow"
              />
            </Link>
            <Link
              to={
                userEmail?.email === "gitasureka@yahoo.co.in" && !isLoginAdmin
                  ? "/profitability/2"
                  : "/profitability/0"
              }
            >
              <img
                className="hidden lg:block h-8 w-auto"
                src={sliderCollapsed ? Fs_icon : logo}
                alt="Workflow"
              />
            </Link>
          </div>
        </div>

        <Menu
          style={{
            paddingTop: "10px",
            paddingBottom: "30px",
            maxHeight: "calc(100vh - 80px)",
            overflowY: "auto",
          }}
        >
          <Menu
            menuItemStyles={{
              button: {
                // the active class will be added automatically by react router
                // so we can use it to style the active menu item
                [`&.active`]: {
                  backgroundColor: "#13395e",
                  color: "#fff",
                },
              },
            }}
          >
            {sliderCollapsed ? (
              <div className="flex justify-center items-center mx-1 p-2">
                <div
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    padding: "10px 4px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    width: "20px",
                    height: "15px",
                    backgroundColor: "white",
                  }}
                  onClick={handleSliderCollapse}
                >
                  {<RightOutlined />}
                </div>
              </div>
            ) : (
              <div className="flex justify-between items-center mx-2">
                <p className="px-4 py-2 text-gray-400 text-xs block">Menu</p>
                <div
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    padding: "10px 4px",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    width: "20px",
                    height: "15px",
                    backgroundColor: "white",
                  }}
                  onClick={handleSliderCollapse}
                >
                  {<LeftOutlined />}
                </div>
              </div>
            )}
            {(isLoginAdmin ||
              // && (isAgencyLogin === null || !isAgencyLogin)
              (isLoginAdmin &&
                adminEmail === "sathish.subramani@forcesight.in") ||
              (isLoginAdmin && adminEmail === "supreethanand1001@gmail.com") ||
              (moduleAccess && moduleAccess.helixai_module) ||
              allowedEmails.includes(userEmail?.email)) && (
              <MenuItem
                icon={
                  <svg
                    width="24"
                    height="10"
                    viewBox="0 0 24 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.84033 1.59226C7.13215 1.28562 7.47587 1.01816 7.85242 0.802608C8.22897 0.587056 8.63572 0.418109 9.05517 0.291531C9.47568 0.168132 9.90943 0.085513 10.348 0.041026C10.4586 0.0320223 10.5646 0.0203722 10.68 0.016136C10.7955 0.0108393 10.9115 0.0113686 11.0269 0.0150755C11.2584 0.0235489 11.4893 0.0484398 11.7154 0.0929268C11.9421 0.136355 12.1645 0.195143 12.3822 0.266111C12.5993 0.338138 12.8106 0.424467 13.0161 0.519267C13.4287 0.707809 13.8137 0.941899 14.1786 1.19611C14.5441 1.45086 14.8836 1.73473 15.2082 2.03078C15.5307 2.32895 15.8331 2.64566 16.1218 2.97137C16.4083 3.29973 16.6773 3.64133 16.9342 3.99246C17.0608 4.16935 17.1831 4.34942 17.3028 4.53478L17.3923 4.67619L17.4347 4.74557L17.4654 4.79323L17.6322 5.03739C18.0919 5.69305 18.611 6.31958 19.1676 6.90268C19.7269 7.48314 20.3349 8.01751 21.0117 8.4555C21.6875 8.89349 22.4411 9.22609 23.28 9.35743C22.8611 9.42205 22.4242 9.4141 21.9957 9.34207C21.5662 9.27269 21.1452 9.14294 20.7411 8.97559C19.9323 8.63716 19.1962 8.14568 18.5305 7.58747C18.3642 7.44712 18.2016 7.30254 18.0422 7.15478C17.8849 7.0049 17.7313 6.85184 17.5803 6.69507C17.2774 6.38313 16.9972 6.05159 16.7261 5.70788C16.6578 5.62155 16.5926 5.53363 16.5269 5.44148L16.502 5.40653L16.4697 5.35939L16.4279 5.29584L16.3453 5.17456C16.2325 5.01144 16.1133 4.84938 15.9915 4.68943C15.7511 4.3669 15.4958 4.05443 15.231 3.75255C14.9688 3.44855 14.6924 3.15779 14.4064 2.88134C14.1225 2.60223 13.8227 2.34325 13.514 2.10069C12.8954 1.61927 12.2217 1.22047 11.4988 1.00227C11.3177 0.949841 11.135 0.905354 10.9491 0.876225C10.8564 0.861926 10.7632 0.850275 10.6694 0.843389C10.5752 0.835975 10.4719 0.83227 10.3734 0.825385C9.97511 0.811086 9.57366 0.822203 9.1738 0.86722C8.77395 0.911178 8.37674 0.992742 7.98482 1.10926C7.59503 1.22789 7.21159 1.38783 6.84033 1.59226Z"
                      fill="#007FFF"
                    />
                    <path
                      d="M17.0479 8.19192C16.756 8.49856 16.4123 8.76602 16.0358 8.98157C15.6592 9.19712 15.2525 9.36607 14.833 9.49265C14.4125 9.61605 13.9788 9.69867 13.5402 9.74315C13.4295 9.75216 13.3236 9.76381 13.2082 9.76804C13.0927 9.77334 12.9767 9.77281 12.8613 9.7691C12.6298 9.76063 12.3989 9.73574 12.1728 9.69125C11.9461 9.64782 11.7237 9.58904 11.506 9.51807C11.2889 9.44604 11.0775 9.35971 10.872 9.26491C10.4595 9.07637 10.0744 8.84228 9.70955 8.58807C9.34411 8.33332 9.00463 8.04945 8.67998 7.7534C8.35745 7.45523 8.05504 7.13852 7.7664 6.81281C7.47988 6.48445 7.21084 6.14285 6.95397 5.79172C6.8274 5.61483 6.70506 5.43476 6.58536 5.2494L6.49586 5.10799L6.45349 5.03861L6.42277 4.99095L6.25595 4.74679C5.79624 4.09113 5.27722 3.4646 4.7206 2.8815C4.16133 2.30104 3.55333 1.76667 2.87649 1.32868C2.2007 0.890687 1.44707 0.558089 0.608162 0.426745C1.02709 0.362132 1.46402 0.370078 1.89247 0.442106C2.32199 0.511485 2.74303 0.641236 3.14712 0.808593C3.95584 1.14702 4.692 1.6385 5.35772 2.19671C5.52402 2.33706 5.68661 2.48164 5.84603 2.6294C6.00332 2.77928 6.15691 2.93234 6.30785 3.08911C6.61079 3.40105 6.89095 3.73259 7.16211 4.0763C7.23043 4.16263 7.29557 4.25055 7.36125 4.3427L7.38614 4.37765L7.41844 4.42479L7.46028 4.48834L7.5429 4.60962C7.65571 4.77274 7.77487 4.9348 7.89668 5.09475C8.13713 5.41728 8.3924 5.72975 8.65721 6.03163C8.91937 6.33563 9.19582 6.62639 9.48181 6.90284C9.76569 7.18195 10.0654 7.44093 10.3742 7.68349C10.9928 8.16491 11.6665 8.56371 12.3894 8.78191C12.5705 8.83434 12.7532 8.87883 12.9391 8.90795C13.0318 8.92225 13.125 8.9339 13.2188 8.94079C13.313 8.9482 13.4163 8.95191 13.5148 8.95879C13.9131 8.97309 14.3145 8.96198 14.7144 8.91696C15.1142 8.873 15.5114 8.79144 15.9034 8.67492C16.2932 8.55629 16.6766 8.39635 17.0479 8.19192Z"
                      fill="#2C2B30"
                    />
                  </svg>
                }
                component={<Link to="/helix-ai" />}
                style={{
                  ...getMenuItemStyles("/helix-ai"),
                  fontWeight: "500",
                }}
                title="Helix AI"
                onClick={handleSliderCollapse}
              >
                Helix AI (Beta)
              </MenuItem>
            )}
            {(isLoginAdmin ||
              (moduleAccess && moduleAccess?.helix_money_module) ||
              allowedEmails.includes(userEmail?.email)) && (
              <SubMenu
                title="Money"
                label="Money"
                open={moneyOpen}
                onClick={handleMoneyClick}
                icon={
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke={
                      isParentMenuActive([
                        "/money",
                        "/money/tracking",
                        "/money/team",
                        "/money/dashboard",
                      ])
                        ? "#1976D2"
                        : "#027FFF"
                    }
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                }
                style={getSubMenuStyles([
                  "/money",
                  "/money/tracking",
                  "/money/team",
                  "/money/dashboard",
                ])}
              >
                <MenuItem
                  title="The Brief"
                  component={<Link to="/money" />}
                  style={{
                    ...getMenuItemStyles("/money"),
                    marginLeft: "20px",
                  }}
                >
                  The Brief
                </MenuItem>
                <MenuItem
                  title="Tracking"
                  component={<Link to="/money/tracking" />}
                  style={{
                    ...getMenuItemStyles("/money/tracking"),
                    marginLeft: "20px",
                  }}
                >
                  Tracking
                </MenuItem>
                <MenuItem
                  title="Team performance"
                  component={<Link to="/money/team" />}
                  style={{
                    ...getMenuItemStyles("/money/team"),
                    marginLeft: "20px",
                  }}
                >
                  Team performance
                </MenuItem>
                <MenuItem
                  title="Analyst Dashboard"
                  component={<Link to="/money/dashboard" />}
                  style={{
                    ...getMenuItemStyles("/money/dashboard"),
                    marginLeft: "20px",
                  }}
                >
                  Analyst Dashboard
                </MenuItem>
              </SubMenu>
            )}
            {(isLoginAdmin ||
              (moduleAccess && moduleAccess.ppr_module) ||
              allowedEmails.includes(userEmail?.email)) && (
              <MenuItem
                icon={
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.2697 14.8018C9.4046 12.3646 6.95912 11.0013 4.97084 11.0248C4.97084 11.2746 4.96807 11.5253 4.97176 11.7761C4.97683 12.124 4.8699 12.4148 4.54313 12.578C4.22881 12.7352 3.93937 12.6623 3.66191 12.4619C2.71202 11.7747 1.75613 11.0953 0.805316 10.4095C0.249483 10.0085 0.250405 9.4292 0.804394 9.03099C1.75014 8.35118 2.69911 7.67552 3.64255 6.99248C3.9237 6.78877 4.21267 6.69336 4.54083 6.86066C4.87682 7.03212 4.97821 7.33031 4.97176 7.6852C4.96715 7.92901 4.97084 8.17282 4.97084 8.41985C5.38149 8.46825 5.77233 8.49037 6.15302 8.56365C9.47051 9.20291 11.6878 11.1262 12.8101 14.31C12.8751 14.4944 12.9571 14.5898 13.1526 14.6465C15.0523 15.1995 16.3129 17.0666 16.1594 19.0793C16.0133 20.9998 14.4642 22.6166 12.5225 22.8757C9.99269 23.2135 7.73203 21.2888 7.72926 18.7369C7.72742 17.0196 8.53444 15.7402 10.0503 14.9193C10.1107 14.8866 10.1734 14.858 10.2351 14.8271C10.2416 14.8239 10.2476 14.8184 10.2697 14.8023V14.8018ZM13.6088 18.6866C13.6568 17.8635 12.9258 17.0823 12.057 17.0279C11.132 16.9703 10.3342 17.6791 10.2789 18.6078C10.225 19.5112 10.9274 20.3021 11.833 20.3578C12.8018 20.4177 13.5489 19.7144 13.6088 18.6866Z"
                      fill="#8E6BFF"
                    />
                    <path
                      d="M18.9021 10.9963C17.0203 11.1124 15.5316 11.8918 14.354 13.3796C14.2784 13.2892 14.1973 13.2183 14.1489 13.1298C13.7973 12.4864 13.459 11.8356 13.0999 11.1963C13.0267 11.0659 13.0414 11.0037 13.1377 10.9087C14.5176 9.55141 16.1653 8.74947 18.0872 8.5158C18.2923 8.49091 18.4988 8.47432 18.7053 8.47017C18.8505 8.46694 18.9118 8.42039 18.9044 8.26784C18.8938 8.04615 18.9007 7.82354 18.9025 7.60093C18.9058 7.27785 19.0261 7.01744 19.3233 6.86489C19.6197 6.71279 19.9027 6.76165 20.1663 6.95015C21.1503 7.65485 22.1352 8.35817 23.1151 9.0684C23.599 9.41914 23.6073 10.0128 23.1261 10.3635C22.1417 11.0806 21.1489 11.7858 20.1589 12.4951C19.9013 12.6795 19.6234 12.721 19.3358 12.5822C19.0357 12.437 18.9085 12.1771 18.903 11.8536C18.8984 11.5793 18.9021 11.3051 18.9021 10.9968V10.9963Z"
                      fill="#8E6BFF"
                    />
                    <path
                      d="M13.2188 5.48984V5.76222C13.2188 6.67478 13.2161 7.58734 13.2216 8.49945C13.2225 8.63587 13.1783 8.71837 13.0714 8.80409C12.6888 9.10966 12.3173 9.42952 11.9279 9.75583C11.6772 9.53737 11.438 9.26683 11.1439 9.08708C10.7217 8.82944 10.6203 8.49161 10.6443 8.02243C10.6826 7.27302 10.6549 6.51992 10.6554 5.76867C10.6554 5.68571 10.6554 5.60321 10.6554 5.48937C10.3752 5.48937 10.1166 5.48384 9.8585 5.49076C9.51513 5.49998 9.23952 5.38521 9.07867 5.06904C8.91828 4.75333 8.99479 4.4662 9.19481 4.1892C9.88615 3.23286 10.5696 2.27098 11.2596 1.31325C11.6421 0.782307 12.2279 0.780464 12.6114 1.31095C13.3073 2.27329 13.9964 3.24115 14.6923 4.20395C14.8882 4.47496 14.9523 4.75933 14.8002 5.0649C14.6421 5.38153 14.3665 5.49859 14.0226 5.49076C13.7641 5.48477 13.5051 5.48937 13.2193 5.48937L13.2188 5.48984Z"
                      fill="#8E6BFF"
                    />
                  </svg>
                }
                component={<Link to="/action-required" />}
                style={{
                  ...getMenuItemStyles("/action-required"),
                  fontWeight: "500",
                }}
                title="Action Required"
              >
                Action Required
              </MenuItem>
            )}

            {(isLoginAdmin ||
              (moduleAccess && moduleAccess.ppr_module) ||
              allowedEmails.includes(userEmail?.email)) && (
              <SubMenu
                title="Profit"
                label="Profit"
                open={optimizeProfitOpen}
                onClick={handleOptimizeProfitClick}
                icon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke={
                      isParentMenuActive([
                        "/profitability/0",
                        "/profit-analysis",
                        "/profitability/2",
                        "/profit-loss-monthly",
                        "/dashboard",
                      ])
                        ? "#1976D2"
                        : "#2196F3"
                    }
                    class="w-5 h-5"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941"
                    />
                  </svg>
                }
                style={getSubMenuStyles([
                  "/profitability/0",
                  "/profit-analysis",
                  "/profitability/2",
                  "/profit-loss-monthly",
                  "/dashboard",
                ])}
              >
                <MenuItem
                  title="Summary"
                  component={<Link to="/profitability/0" />}
                  style={{
                    ...getMenuItemStyles("/profitability/0"),
                    marginLeft: "20px",
                  }}
                >
                  Summary
                </MenuItem>
                <MenuItem
                  title="Sales Summary"
                  component={<Link to="/profit-analysis" />}
                  style={{
                    ...getMenuItemStyles("/profit-analysis"),
                    marginLeft: "20px",
                  }}
                >
                  Sales Trend
                </MenuItem>
                <MenuItem
                  title="Profit - Table view"
                  component={<Link to="/profitability/2" />}
                  style={{
                    ...getMenuItemStyles("/profitability/2"),
                    marginLeft: "20px",
                  }}
                >
                  Profit - Table view
                </MenuItem>
                <MenuItem
                  title="Profit - Monthly View"
                  component={<Link to="/profit-loss-monthly" />}
                  style={{
                    ...getMenuItemStyles("/profit-loss-monthly"),
                    marginLeft: "20px",
                  }}
                >
                  Profit - Monthly View
                </MenuItem>
                <MenuItem
                  title="Make Your Own Report"
                  component={<Link to="/dashboard" />}
                  style={{
                    ...getMenuItemStyles("/dashboard"),
                    marginLeft: "20px",
                  }}
                >
                  Canvas - MYOR
                </MenuItem>
              </SubMenu>
            )}
            {(isLoginAdmin ||
              (moduleAccess && moduleAccess.ppr_module) ||
              allowedEmails.includes(userEmail?.email)) && (
              <SubMenu
                title="Reconcile"
                label="Reconcile"
                open={paymentsOpen}
                onClick={handlePaymentsClick}
                icon={
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.4997 2.33398H4.99967C4.55765 2.33398 4.13372 2.50958 3.82116 2.82214C3.5086 3.1347 3.33301 3.55862 3.33301 4.00065V17.334C3.33301 17.776 3.5086 18.1999 3.82116 18.5125C4.13372 18.8251 4.55765 19.0007 4.99967 19.0007H14.9997C15.4417 19.0007 15.8656 18.8251 16.1782 18.5125C16.4907 18.1999 16.6663 17.776 16.6663 17.334V6.50065L12.4997 2.33398Z"
                      stroke="#FF6600"
                      stroke-width="1.4"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7.5 8.99805H12.5"
                      stroke="#FF6600"
                      stroke-width="1.4"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M10 11.498V6.49805"
                      stroke="#FF6600"
                      stroke-width="1.4"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M7.5 14.834H12.5"
                      stroke="#FF6600"
                      stroke-width="1.4"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                }
                style={getSubMenuStyles([
                  "/payment-tracker/0",
                  "/outstanding-payments",
                  "/payment-tracker/1",
                  "/payment-tracker/2",
                  "/invoice-po",
                  "/amazonvcp-recon",
                  "/quickcommerce-payments",
                  "/po-rec-others",
                  "/quickcommerce-ledger",
                  "/fee-waiver-recon",
                  "/settled-amount-recon",
                  "/returns-summary",
                  "/returns-tracker",
                  "/claims-summary",
                  "/claims",
                  "/manual_claims",
                ])}
              >
                <MenuItem
                  title="Summary"
                  component={<Link to="/payment-tracker/0" />}
                  style={{
                    ...getMenuItemStyles("/payment-tracker/0"),
                    marginLeft: "20px",
                  }}
                  onClick={handlePaymentsCommoncloseClick}
                >
                  Summary
                </MenuItem>
                <MenuItem
                  title="Outstanding Payments"
                  component={<Link to="/outstanding-payments" />}
                  style={{
                    ...getMenuItemStyles("/outstanding-payments"),
                    marginLeft: "20px",
                  }}
                  onClick={handlePaymentsCommoncloseClick}
                >
                  O/S Payments
                </MenuItem>
                <SubMenu
                  title="B2C Reconciliation"
                  label="B2C Reconciliation"
                  open={paymentsReconOpen}
                  onClick={handlePaymentsReconClick}
                  style={{ marginLeft: "20px" }}
                >
                  <MenuItem
                    title="Settled Orders"
                    component={<Link to="/payment-tracker/1" />}
                    style={{
                      ...getMenuItemStyles("/payment-tracker/1"),
                      marginLeft: "40px",
                    }}
                  >
                    Settled Orders
                  </MenuItem>
                  <MenuItem
                    title="Unsettled Orders"
                    component={<Link to="/payment-tracker/2" />}
                    style={{
                      ...getMenuItemStyles("/payment-tracker/2"),
                      marginLeft: "40px",
                    }}
                  >
                    Unsettled Orders
                  </MenuItem>
                  <MenuItem
                    title="Invoice Reconciliation"
                    component={<Link to="/invoice-po" />}
                    style={{
                      ...getMenuItemStyles("/invoice-po"),
                      marginLeft: "40px",
                    }}
                  >
                    Invoice Recon
                  </MenuItem>
                </SubMenu>
                <SubMenu
                  title="B2B Reconciliation"
                  label="B2B Reconciliation"
                  open={paymentsPoOpen}
                  onClick={handlePaymentsPOClick}
                  style={{ marginLeft: "20px" }}
                >
                  <MenuItem
                    title="A-VCP"
                    component={<Link to="/amazonvcp-recon" />}
                    style={{
                      ...getMenuItemStyles("/amazonvcp-recon"),
                      marginLeft: "40px",
                    }}
                  >
                    A-VCP
                  </MenuItem>
                  <MenuItem
                    title="Quick Com"
                    component={<Link to="/quickcommerce-payments" />}
                    style={{
                      ...getMenuItemStyles("/quickcommerce-payments"),
                      marginLeft: "40px",
                    }}
                  >
                    Quick Com
                  </MenuItem>
                  <MenuItem
                    title="All Channels"
                    component={<Link to="/po-rec-others" />}
                    style={{
                      ...getMenuItemStyles("/po-rec-others"),
                      marginLeft: "40px",
                    }}
                  >
                    All Channels
                  </MenuItem>
                  <MenuItem
                    title="Customer Ledger Recon"
                    component={<Link to="/quickcommerce-ledger" />}
                    style={{
                      ...getMenuItemStyles("/quickcommerce-ledger"),
                      marginLeft: "40px",
                    }}
                  >
                    Cust. Ledger
                  </MenuItem>
                </SubMenu>
                <MenuItem
                  title="Fee Leaks"
                  component={<Link to="/fee-waiver-recon" />}
                  style={{
                    ...getMenuItemStyles("/fee-waiver-recon"),
                    marginLeft: "20px",
                  }}
                  onClick={handlePaymentsCommoncloseClick}
                >
                  Fee Leaks
                </MenuItem>
                <MenuItem
                  title="Minimum Settlement Leaks"
                  component={<Link to="/settled-amount-recon" />}
                  style={{
                    ...getMenuItemStyles("/settled-amount-recon"),
                    marginLeft: "20px",
                  }}
                  onClick={handlePaymentsCommoncloseClick}
                >
                  Min. Sett. Leaks
                </MenuItem>

                {(isLoginAdmin ||
                  (moduleAccess && moduleAccess.return_module) ||
                  allowedEmails.includes(userEmail?.email)) && (
                  <SubMenu
                    title="Returns"
                    label="Returns"
                    open={returnsViewOpen}
                    onClick={handleReturnsClick}
                    style={{ marginLeft: "20px" }}
                  >
                    <MenuItem
                      title="Summary"
                      component={<Link to="/returns-summary" />}
                      style={{
                        ...getMenuItemStyles("/returns-summary"),
                        marginLeft: "40px",
                      }}
                    >
                      Summary
                    </MenuItem>
                    <MenuItem
                      title="Ledger"
                      component={<Link to="/returns-tracker" />}
                      style={{
                        ...getMenuItemStyles("/returns-tracker"),
                        marginLeft: "40px",
                      }}
                    >
                      Ledger
                    </MenuItem>
                  </SubMenu>
                )}
                {(isLoginAdmin ||
                  (moduleAccess && moduleAccess.claims_module) ||
                  allowedEmails.includes(userEmail?.email)) && (
                  <SubMenu
                    title="Flipkart Claims"
                    label="Flipkart Claims"
                    open={claimOpen}
                    onClick={handleClaimsClick}
                    style={{ marginLeft: "20px" }}
                  >
                    <MenuItem
                      title="Summary"
                      component={<Link to="/claims-summary" />}
                      style={{
                        ...getMenuItemStyles("/claims-summary"),
                        marginLeft: "40px",
                      }}
                    >
                      Summary
                    </MenuItem>
                    <MenuItem
                      title="Claims Details"
                      component={<Link to="/claims" />}
                      style={{
                        ...getMenuItemStyles("/claims"),
                        marginLeft: "40px",
                      }}
                    >
                      Claims Details
                    </MenuItem>
                    {/* <MenuItem
                      title="Other Channels"
                      component={<Link to="/manual_claims" />}
                      style={{
                        ...getMenuItemStyles("/manual_claims"),
                        marginLeft: "40px",
                      }}
                    >
                      Other Channels
                    </MenuItem> */}
                  </SubMenu>
                )}
              </SubMenu>
            )}
            {/* New Payments screen - to be added in above Reconcile menu once Tested */}
            {
              //  (isLoginAdmin && (adminEmail?.endsWith("@forcesight.ai") ||
              //                   adminEmail?.endsWith("@forcesight.in") || adminEmail === "pradeep.ram.fs@gmail.com")) &&
              (isLoginAdmin ||
                (moduleAccess && moduleAccess.ppr_module) ||
                allowedEmails.includes(userEmail?.email)) && (
                <SubMenu
                  title="Reconcile(Beta)"
                  label="Reconcile(Beta)"
                  open={newPaymentsOpen}
                  onClick={handleNewPaymentsClick}
                  icon={
                    <svg
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.4997 2.33398H4.99967C4.55765 2.33398 4.13372 2.50958 3.82116 2.82214C3.5086 3.1347 3.33301 3.55862 3.33301 4.00065V17.334C3.33301 17.776 3.5086 18.1999 3.82116 18.5125C4.13372 18.8251 4.55765 19.0007 4.99967 19.0007H14.9997C15.4417 19.0007 15.8656 18.8251 16.1782 18.5125C16.4907 18.1999 16.6663 17.776 16.6663 17.334V6.50065L12.4997 2.33398Z"
                        stroke="#FF6600"
                        stroke-width="1.4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.5 8.99805H12.5"
                        stroke="#FF6600"
                        stroke-width="1.4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M10 11.498V6.49805"
                        stroke="#FF6600"
                        stroke-width="1.4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.5 14.834H12.5"
                        stroke="#FF6600"
                        stroke-width="1.4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  }
                  style={getSubMenuStyles([
                    "/payments-summary",
                    "/payments-outstanding",
                    "/payments-bank-transfer",
                    "/payments-b2c",
                    "/po-rec-others",
                    "/b2B-recon-summary",
                    "/payments-d2c",
                    "/invoice-po",
                    "/fee-waiver-recon",
                    "/settled-amount-recon",
                  ])}
                >
                    <MenuItem
                    title="Outstanding Payments"
                    component={<Link to="/payments-outstanding" />}
                    style={{
                      ...getMenuItemStyles("/payments-outstanding"),
                      marginLeft: "20px",
                    }}
                    onClick={handleNewPaymentsCommoncloseClick}
                  >
                    O/S Payments
                  </MenuItem>

                  <MenuItem
                    title="Bank Transfer"
                    component={<Link to="/payments-bank-transfer" />}
                    style={{
                      ...getMenuItemStyles("/payments-bank-transfer"),
                      marginLeft: "20px",
                    }}
                    onClick={handleNewPaymentsCommoncloseClick}
                  >
                    Bank Transfer
                  </MenuItem>
                  <MenuItem
                    title="Payment Summary"
                    component={<Link to="/payments-summary" />}
                    style={{
                      ...getMenuItemStyles("/payments-summary"),
                      marginLeft: "20px",
                    }}
                    onClick={handleNewPaymentsCommoncloseClick}
                  >
                    Payment Summary
                  </MenuItem>
                  <MenuItem
                    title="Payment B2C"
                    component={<Link to="/payments-b2c" />}
                    style={{
                      ...getMenuItemStyles("/payments-b2c"),
                      marginLeft: "20px",
                    }}
                    onClick={handleNewPaymentsCommoncloseClick}
                  >
                    Payment B2C
                  </MenuItem>
                   <MenuItem
                    title="Payment D2C"
                    component={<Link to="/payments-d2c" />}
                    style={{
                      ...getMenuItemStyles("/payments-d2c"),
                      marginLeft: "20px",
                    }}
                    onClick={handleNewPaymentsCommoncloseClick}
                  >
                    Payment D2C
                  </MenuItem>
                  <SubMenu
                    title="Payment B2B"
                    label=" Payment B2B"
                    open={paymentsPoOpen}
                    onClick={handlePaymentsPOClick}
                    style={{ marginLeft: "20px" }}
                  >
                    <MenuItem
                      title="Recon Summary"
                      component={<Link to="/b2B-recon-summary" />}
                      style={{
                        ...getMenuItemStyles("/b2B-recon-summary"),
                        marginLeft: "40px",
                      }}
                    >
                      Recon Summary
                    </MenuItem>
                    <MenuItem
                      title="All Channels"
                      component={<Link to="/po-rec-others" />}
                      style={{
                        ...getMenuItemStyles("/po-rec-others"),
                        marginLeft: "40px",
                      }}
                    >
                      All Channels
                    </MenuItem>
                    <MenuItem
                      title="Customer Ledger Recon"
                      component={<Link to="/quickcommerce-ledger" />}
                      style={{
                        ...getMenuItemStyles("/quickcommerce-ledger"),
                        marginLeft: "40px",
                      }}
                    >
                      Cust. Ledger
                    </MenuItem>
                  </SubMenu>

                 

                  <MenuItem
                    title="Fee Leaks"
                    component={<Link to="/fee-waiver-recon" />}
                    style={{
                      ...getMenuItemStyles("/fee-waiver-recon"),
                      marginLeft: "20px",
                    }}
                    onClick={handleNewPaymentsCommoncloseClick}
                  >
                    Fee Leaks
                  </MenuItem>
                  <MenuItem
                    title="Minimum Settlement Leaks"
                    component={<Link to="/settled-amount-recon" />}
                    style={{
                      ...getMenuItemStyles("/settled-amount-recon"),
                      marginLeft: "20px",
                    }}
                    onClick={handleNewPaymentsCommoncloseClick}
                  >
                    Min. Sett. Leaks
                  </MenuItem>
                 

                  {(isLoginAdmin ||
                    (moduleAccess && moduleAccess.return_module) ||
                    allowedEmails.includes(userEmail?.email)) && (
                    <SubMenu
                      title="Returns"
                      label="Returns"
                      open={returnsViewOpen}
                      onClick={handleReturnsClick}
                      style={{ marginLeft: "20px" }}
                    >
                      <MenuItem
                        title="Summary"
                        component={<Link to="/returns-summary" />}
                        style={{
                          ...getMenuItemStyles("/returns-summary"),
                          marginLeft: "40px",
                        }}
                      >
                        Summary
                      </MenuItem>
                      <MenuItem
                        title="Ledger"
                        component={<Link to="/returns-tracker" />}
                        style={{
                          ...getMenuItemStyles("/returns-tracker"),
                          marginLeft: "40px",
                        }}
                      >
                        Ledger
                      </MenuItem>
                    </SubMenu>
                  )}
                  {(isLoginAdmin ||
                    (moduleAccess && moduleAccess.claims_module) ||
                    allowedEmails.includes(userEmail?.email)) && (
                    <SubMenu
                      title="Flipkart Claims"
                      label="Flipkart Claims"
                      open={claimOpen}
                      onClick={handleClaimsClick}
                      style={{ marginLeft: "20px" }}
                    >
                      <MenuItem
                        title="Summary"
                        component={<Link to="/claims-summary" />}
                        style={{
                          ...getMenuItemStyles("/claims-summary"),
                          marginLeft: "40px",
                        }}
                      >
                        Summary
                      </MenuItem>
                      <MenuItem
                        title="Claims Details"
                        component={<Link to="/claims" />}
                        style={{
                          ...getMenuItemStyles("/claims"),
                          marginLeft: "40px",
                        }}
                      >
                        Claims Details
                      </MenuItem>
                    </SubMenu>
                  )}
                   <MenuItem
                    title="Inv to Profit Recon"
                    component={<Link to="/invoice-po" />}
                    style={{
                      ...getMenuItemStyles("/invoice-po"),
                      marginLeft: "20px",
                    }}
                    onClick={handleNewPaymentsCommoncloseClick}
                  >
                    Inv to Profit Recon
                  </MenuItem>
                </SubMenu>
              )
            }

            {(isLoginAdmin ||
              (moduleAccess && moduleAccess?.inventory_module) ||
              allowedEmails.includes(userEmail?.email)) && (
              <SubMenu
                title="Plan Inventory"
                label="Plan Inventory"
                open={inventoryOpen}
                onClick={handleInventoryClick}
                icon={
                  <svg
                    class="w-5 h-5"
                    viewBox="0 0 16 16"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill={
                        isParentMenuActive(["/inventory/2", "/inventory/3"])
                          ? "#5D4037"
                          : "#795548"
                      }
                      d="M12 6v-4l-4-2-4 2v4l-4 2v5l4 2 4-2 4 2 4-2v-5zM8.090 1.12l2.91 1.44-2.6 1.3-2.91-1.44zM5 2.78l3 1.5v3.6l-3-1.5v-3.6zM4 13.88l-3-1.5v-3.6l3 1.5v3.6zM4.28 9.88l-2.88-1.46 2.6-1.3 2.88 1.44zM12 13.88l-3-1.5v-3.6l3 1.5v3.6zM12.28 9.88l-2.88-1.46 2.6-1.3 2.88 1.44z"
                    ></path>
                  </svg>
                }
                style={getSubMenuStyles(["/inventory/2", "/inventory/3"])}
              >
                <MenuItem
                  title="Ledger"
                  component={<Link to="/inventory/2" />}
                  style={{
                    ...getMenuItemStyles("/inventory/2"),
                    marginLeft: "20px",
                  }}
                >
                  Ledger
                </MenuItem>
                <MenuItem
                  title="Restock Plan"
                  component={<Link to="/inventory/3" />}
                  style={{
                    ...getMenuItemStyles("/inventory/3"),
                    marginLeft: "20px",
                  }}
                >
                  Restock Plan
                </MenuItem>
              </SubMenu>
            )}

            {(isLoginAdmin ||
              (moduleAccess && moduleAccess?.inventory_module) ||
              allowedEmails.includes(userEmail?.email)) && (
              <SubMenu
                title="Inventory"
                label="Inventory"
                open={inventoryTabOpen}
                onClick={handleInventoryTabClick}
                icon={
                  <svg
                    className="w-5 h-5"
                    viewBox="0 0 16 16"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill={
                        isParentMenuActive(["/demand-forecasting"])
                          ? "#5D4037"
                          : "#795548"
                      }
                      d="M12 6v-4l-4-2-4 2v4l-4 2v5l4 2 4-2 4 2 4-2v-5zM8.090 1.12l2.91 1.44-2.6 1.3-2.91-1.44zM5 2.78l3 1.5v3.6l-3-1.5v-3.6zM4 13.88l-3-1.5v-3.6l3 1.5v3.6zM4.28 9.88l-2.88-1.46 2.6-1.3 2.88 1.44zM12 13.88l-3-1.5v-3.6l3 1.5v3.6zM12.28 9.88l-2.88-1.46 2.6-1.3 2.88 1.44z"
                    ></path>
                  </svg>
                }
                style={getSubMenuStyles(["/demand-forecasting"])}
              >
                <MenuItem
                  title="Demand Forecasting"
                  component={<Link to="/demand-forecasting" />}
                  style={{
                    ...getMenuItemStyles("/demand-forecasting"),
                    // 8px, not the usual 20px: the label needs the width or
                    // it truncates to "Demand Forecasti...".
                    marginLeft: "8px",
                  }}
                >
                  Demand Forecasting
                </MenuItem>
              </SubMenu>
            )}

            {((isLoginAdmin && adminEmail === "adithijain214@gmail.com") ||
              (moduleAccess && moduleAccess?.review_module)) && (
              <SubMenu
                title="Brand Intelligence"
                icon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke={
                      isParentMenuActive([
                        "/reviews/0",
                        "/reviews/1",
                        "/reviews/3",
                        "/reviews/4",
                        "/reviews/5",
                      ])
                        ? "#1976D2"
                        : "currentColor"
                    }
                    class="w-5 h-5"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z"
                    />
                  </svg>
                }
                label="Brand Intelligence"
                open={reviewsOpen}
                onClick={handleReviewsClick}
                style={getSubMenuStyles([
                  "/reviews/0",
                  "/reviews/1",
                  "/reviews/3",
                  "/reviews/4",
                  "/reviews/5",
                ])}
              >
                <MenuItem
                  component={<Link to="/reviews/0" />}
                  style={{
                    ...getMenuItemStyles("/reviews/0"),
                    marginLeft: "20px",
                  }}
                >
                  Summary
                </MenuItem>
                <MenuItem
                  component={<Link to="/reviews/1" />}
                  style={{
                    ...getMenuItemStyles("/reviews/1"),
                    marginLeft: "20px",
                  }}
                >
                  Product View
                </MenuItem>
                <MenuItem
                  component={<Link to="/reviews/3" />}
                  style={{
                    ...getMenuItemStyles("/reviews/3"),
                    marginLeft: "20px",
                  }}
                >
                  Review Analyser
                </MenuItem>
                <MenuItem
                  component={<Link to="/reviews/4" />}
                  style={{
                    ...getMenuItemStyles("/reviews/4"),
                    marginLeft: "20px",
                  }}
                >
                  Campaign
                </MenuItem>
                <MenuItem
                  component={<Link to="/reviews/5" />}
                  style={{
                    ...getMenuItemStyles("/reviews/5"),
                    marginLeft: "20px",
                  }}
                >
                  Seller Reviews
                </MenuItem>
              </SubMenu>
            )}
            {/* {((isLoginAdmin && adminEmail === "adithijain214@gmail.com") ||
              (moduleAccess &&
                (moduleAccess?.buybox_module ||
                  moduleAccess?.pricing_module))
                ) 
                  && (
              <SubMenu
                title="Product Intelligence"
                icon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke={
                      isParentMenuActive([
                        "/PricetrackerV2",
                        "/sales-defence/1",
                        "/buybox-multiple-pincode",
                        "/price-tracker/3",
                        "/price-tracker/2",
                      ])
                        ? "#1976D2"
                        : "currentColor"
                    }
                    data-slot="icon"
                    class="w-5 h-5"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="m3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z"
                    />
                  </svg>
                }
                label="Product Intelligence"
                open={productIntelOpen}
                onClick={handleProductIntelClick}
                style={getSubMenuStyles([
                  "/PricetrackerV2",
                  "/sales-defence/1",
                  "/buybox-multiple-pincode",
                  "/price-tracker/3",
                  "/price-tracker/2",
                ])}
              >
                {(isLoginAdmin ||
                  (moduleAccess && moduleAccess?.pricing_module)) && (
                  <MenuItem
                    component={<Link to="/PricetrackerV2" />}
                    style={{
                      ...getMenuItemStyles("/PricetrackerV2"),
                      marginLeft: "20px",
                    }}
                  >
                    Pricing
                  </MenuItem>
                )}
                {(isLoginAdmin ||
                  (moduleAccess && moduleAccess?.buybox_module)) && (
                  <SubMenu
                    title="Buybox"
                    label="Buybox"
                    component={<Link to="/sales-defence/1" />}
                    style={{
                      ...getMenuItemStyles("/sales-defence/1"),
                      marginLeft: "20px",
                    }}
                    open={buyboxOpen}
                    onClick={handleBuyboxClick}
                  >
                    <MenuItem
                      component={<Link to="/buybox-multiple-pincode" />}
                      style={{
                        ...getMenuItemStyles("/buybox-multiple-pincode"),
                        marginLeft: "40px",
                      }}
                    >
                      Mulitple Pincodes
                    </MenuItem>
                  </SubMenu>
                )}

                {(isLoginAdmin ||
                  (moduleAccess && moduleAccess?.pricing_module)) && (
                  <SubMenu
                    title="Compliance"
                    label="Compliance"
                    open={complianceViewOpen}
                    onClick={handleComplianceViewClick}
                    style={{ marginLeft: "20px" }}
                  >
                    <MenuItem
                      component={<Link to="/price-tracker/3" />}
                      style={{
                        ...getMenuItemStyles("/price-tracker/3"),
                        marginLeft: "40px",
                      }}
                    >
                      Price Compliance
                    </MenuItem>
                    <MenuItem
                      component={<Link to="/price-tracker/2" />}
                      style={{
                        ...getMenuItemStyles("/price-tracker/2"),
                        marginLeft: "40px",
                      }}
                    >
                      Discount Compliance
                    </MenuItem>
                  </SubMenu>
                )}
              </SubMenu>
            )} */}
            <MenuItem
              title="Downloads"
              icon={
                <svg
                  width="20"
                  height="21"
                  viewBox="0 0 20 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 13.166V3.16602"
                    stroke="#0A335C"
                    stroke-width="1.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17.5 13.166V16.4993C17.5 16.9414 17.3244 17.3653 17.0118 17.6779C16.6993 17.9904 16.2754 18.166 15.8333 18.166H4.16667C3.72464 18.166 3.30072 17.9904 2.98816 17.6779C2.67559 17.3653 2.5 16.9414 2.5 16.4993V13.166"
                    stroke="#0A335C"
                    stroke-width="1.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5.83301 9L9.99967 13.1667L14.1663 9"
                    stroke="#0A335C"
                    stroke-width="1.4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              }
              component={<Link to="/downloads" />}
              style={{ ...getMenuItemStyles("/downloads"), fontWeight: "500" }}
            >
              Downloads
            </MenuItem>
            <SubMenu
              title="Settings"
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="#6B0CC4"
                  class="w-5 h-5"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 011.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.56.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.893.149c-.425.07-.765.383-.93.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 01-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.397.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 01-.12-1.45l.527-.737c.25-.35.273-.806.108-1.204-.165-.397-.505-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.107-1.204l-.527-.738a1.125 1.125 0 01.12-1.45l.773-.773a1.125 1.125 0 011.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894z"
                  />
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
              }
              label="Settings"
              open={settingsOpen}
              onClick={handleSettingsClick}
              style={getSubMenuStyles([
                "/overview-settings",
                "/product-configuration",
                "/finance-configuration",
                "/reviews/6",
                "/account-settings/account",
                "/marketplace-settings-dashboard",
                "/account-settings/user",
              ])}
            >
              <SubMenu
                title="Product Settings"
                label="Product Settings"
                open={productSettingsOpen}
                onClick={handleProductSettingsClick}
                style={{ marginLeft: "20px" }}
              >
                <MenuItem
                  title="Overview"
                  component={<Link to="/overview-settings" />}
                  style={{
                    ...getMenuItemStyles("/overview-settings"),
                    marginLeft: "40px",
                  }}
                >
                  Overview
                </MenuItem>

                <MenuItem
                  title="Product Configuration"
                  component={<Link to="/product-configuration" />}
                  style={{
                    ...getMenuItemStyles("/product-configuration"),
                    marginLeft: "40px",
                  }}
                >
                  Product Config
                </MenuItem>

                <MenuItem
                  title="Finance Configuration"
                  component={<Link to="/finance-configuration" />}
                  style={{
                    ...getMenuItemStyles("/finance-configuration"),
                    marginLeft: "40px",
                  }}
                >
                  Finance Config
                </MenuItem>
                {/* {(isLoginAdmin ||
                  (moduleAccess && moduleAccess?.review_module) ||
                  allowedEmails.includes(userEmail?.email)) && (
                  <MenuItem
                    title="Reviews Modularity"
                    component={<Link to="/reviews/6" />}
                    style={{
                      ...getMenuItemStyles("/reviews/6"),
                      marginLeft: "40px",
                    }}
                  >
                    Reviews Modularity
                  </MenuItem>
                )} */}
                {/* {(isLoginAdmin ||
                  (moduleAccess && moduleAccess?.buybox_module) ||
                  allowedEmails.includes(userEmail?.email)) && (
                  <MenuItem
                    title="Buybox Modularity"
                    component={<Link to="/sales-defence/2" />}
                    style={{
                      ...getMenuItemStyles("/sales-defence/2"),
                      marginLeft: "40px",
                    }}
                  >
                    Buybox Modularity
                  </MenuItem>
                )} */}
              </SubMenu>
              <SubMenu
                title="User Settings"
                label="User Settings"
                open={userSettingsOpen}
                onClick={handleUserSettingsClick}
                style={{ marginLeft: "20px" }}
              >
                <MenuItem
                  title="Account Settings"
                  component={<Link to="/account-settings/account" />}
                  style={{
                    ...getMenuItemStyles("/account-settings/account"),
                    marginLeft: "40px",
                  }}
                >
                  Account Settings
                </MenuItem>
                <MenuItem
                  title="Marketplace Settings"
                  component={<Link to="/marketplace-settings-dashboard" />}
                  style={{
                    ...getMenuItemStyles("/marketplace-settings-dashboard"),
                    marginLeft: "40px",
                  }}
                >
                  Marketplace Settings
                </MenuItem>
                <MenuItem
                  title="User Management"
                  component={<Link to="/account-settings/user" />}
                  style={{
                    ...getMenuItemStyles("/account-settings/user"),
                    marginLeft: "40px",
                  }}
                >
                  User Management
                </MenuItem>
              </SubMenu>
              <MenuItem onClick={handleLogoutClick}>Logout</MenuItem>
            </SubMenu>
          </Menu>
        </Menu>
      </Sidebar>
      <main
        className="inner"
        style={{
          marginLeft: sliderCollapsed ? "72px" : "228px",
          transition: "margin-left 1000ms ease-in-out",
        }}
      >
        {" "}
        {children}
      </main>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomSideBar);
